import { render, staticRenderFns } from "./index-email-inbox.vue?vue&type=template&id=2a7f5a7a&"
import script from "./index-email-inbox.vue?vue&type=script&lang=js&"
export * from "./index-email-inbox.vue?vue&type=script&lang=js&"
import style0 from "./index-email-inbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports